import { connect } from 'react-redux';
import * as actions from './actions'
import Transcriptions from './Transcriptions';

const mapStateToProps = (state, props) => {
  return {
    isFetching: state.transcriptions.isFetchingTranscriptions,
    roomRecordings: state.transcriptions.transcriptions,
    view: state.loginLayout.view,
    ...props
  };
}

const mapDispatchToProps = dispatch => ({
  fetchRoomRecordings: (token, transcriptions, searchObject) => dispatch(actions.fetchTranscriptions(token, transcriptions, searchObject)),
  resetSearch: () => dispatch(actions.resetSearch())
})

const TranscriptionContainer = connect(mapStateToProps, mapDispatchToProps)(Transcriptions);

export default TranscriptionContainer;


// WEBPACK FOOTER //
// src/routes/Transcriptions/TranscriptionContainer.js